import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const knowledgeHubAllArticlesRoute: InvariantJiraRoute = {
	name: 'knowledge-hub-all-articles',
	path: '/jira/servicedesk/projects/:projectKey/knowledge/browse/page/:pageId',
};
